module.exports = __webpack_public_path__ + "static/media/THKCo.bcf1a42b.png";